/* eslint-disable line-comment-position */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import { StyledEngineProvider } from '@mui/material/styles';
import { HelmetProvider } from 'react-helmet-async';
import { SnackbarProvider } from 'notistack';
import { MainTheme } from './theme';
import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';
import packageJson from '../package.json';

import { CustomToastContainer } from './components/CustomToastContainer';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

// Sentry disabled — was causing slow/blocked requests due to unreachable ingest endpoint.
// TODO: Evaluate whether to upgrade, replace, or remove Sentry before re-enabling.
// Sentry.init({
//   dsn: 'https://b34402d13467494caa6dfe5930c3c2dc@o1252268.ingest.sentry.io/6418319',
//   release: `vipr-ui@${packageJson.version}`,
//   environment: process.env.REACT_APP_ENV,
//   integrations: [new Sentry.BrowserTracing(), new Sentry.Replay({})],
//   tracesSampleRate: Number(process.env.REACT_APP_SENTRY_SAMPLE_RATE) || 1.0,
//   replaysSessionSampleRate: Number(process.env.REACT_APP_SENTRY_REPLAY_SAMPLE_RATE) || 0.1,
//   replaysOnErrorSampleRate: Number(process.env.REACT_APP_SENTRY_REPLAY_ERROR_SAMPLE_RATE) || 1.0,
// });

ReactDOM.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <MainTheme>
        <HelmetProvider>
          <SnackbarProvider
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
          >
            <Provider store={store}>
              <App />
            </Provider>
          </SnackbarProvider>
          <CustomToastContainer />
        </HelmetProvider>
      </MainTheme>
    </StyledEngineProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
